let AblyApiKey = process.env.REACT_APP_ABLY_API_KEY

export { AblyApiKey }
